import React, { Fragment, useState, useEffect } from "react";

const Beneficios = ({beneficio}) => {

    const [value, setValue]= useState(0);

    useEffect(() => {
        if(!beneficio){
            setValue(0);
        }else if(beneficio === 0){
            setValue(0);
        }else if(beneficio === 1){
            setValue(1);
        }else if(beneficio === 2){
            setValue(2);
        }
      }, [beneficio]);

       return(
        <div id="beneficios">
            {
                value === 0 ?
                    <Fragment>
                        <div className="beneficio"><img src="img/beneficios-1.png" alt="beneficio"></img></div>
                        <div className="beneficio"><img src="img/beneficios-2.png" alt="beneficio"></img></div>
                        <div className="beneficio"><img src="img/beneficios-3.png" alt="beneficio"></img></div>
                        <div className="beneficio"><img src="img/beneficios-4.png" alt="beneficio"></img></div>
                    </Fragment>
                    :
                    value === 1 ?
                        <Fragment>
                            <div className="beneficio"><img src="img/beneficios-1.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-2.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-3.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-4.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-5.png" alt="beneficio"></img></div>
                            <div className="beneficio"><img src="img/beneficios-6.png" alt="beneficio"></img></div>
                        </Fragment>
                        :   
                        value === 2 ?
                            <Fragment>
                                <div className="beneficio"><img src="img/beneficios-4.png" alt="beneficio"></img></div>
                                <div className="beneficio"><img src="img/beneficios-5.png" alt="beneficio"></img></div>
                                <div className="beneficio"><img src="img/beneficios-6.png" alt="beneficio"></img></div>
                                <div className="beneficio"><img src="img/beneficios-7.png" alt="beneficio"></img></div>
                                <div className="beneficio"><img src="img/beneficios-8.png" alt="beneficio"></img></div>
                                <div className="beneficio"><img src="img/beneficios-9.png" alt="beneficio"></img></div>
                            </Fragment>
                            :
                            null

            }
            <div className="clear"></div>
        </div>
    )
}

export default Beneficios;